import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import TimeProfilesHelpModal from "./Help";
import TimeProfileSettingsHelpModal from "./SettingsHelp";
import timeComposition from "./composition";
import { composedAPI } from "./api";

const ConfigTimeProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...timeComposition}
      {...composedAPI}
      {...settings}
    />
    <TimeProfilesHelpModal />
    <TimeProfileSettingsHelpModal />
  </>
);

export default ConfigTimeProfiles;
